import React from "react";
import { clsx } from "clsx";

const SkipLinkBase = (
  props: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > & { topOffset?: string },
) => {
  const { topOffset = "focus:top-midi", ...restProps } = props;
  return (
    <a
      {...restProps}
      className={clsx(
        props.className,
        "px-3 fixed -left-peta -top-peta z-100 bg-warning py-midi text-white focus:left-midi focus-visible:!outline-warning",
        topOffset,
      )}
    />
  );
};

export const SkipLinks = () => (
  <>
    <SkipLinkBase href="#content-main">Skip to Content</SkipLinkBase>
    <SkipLinkBase href="#footer">Skip to Footer</SkipLinkBase>
  </>
);
